import { API_CONFIG } from '../config/settings'
import { isDemoCheckoutPhone } from './checkoutConfig'

export type CashfreeClientMode = 'sandbox' | 'production'

let cachedMode: CashfreeClientMode | null = null

/**
 * Resolve Cashfree JS mode from API so live builds stay aligned with backend
 * (sandbox vs production credentials).
 */
export async function getCashfreeClientMode(phone?: string | null): Promise<CashfreeClientMode> {
  if (isDemoCheckoutPhone(phone)) return 'sandbox'

  const envMode = (import.meta.env.VITE_CASHFREE_MODE as string | undefined)?.trim().toLowerCase()
  if (envMode === 'production' || envMode === 'prod') return 'production'
  if (envMode === 'sandbox' || envMode === 'test') return 'sandbox'

  if (cachedMode) return cachedMode

  try {
    const base = API_CONFIG.BASE_URL.replace(/\/$/, '')
    const q = phone ? `?phone=${encodeURIComponent(phone)}` : ''
    const res = await fetch(`${base}/payments/cashfree/client-config${q}`)
    if (res.ok) {
      const data = await res.json()
      const mode = String(data?.mode || '').toLowerCase()
      if (mode === 'production' || mode === 'prod') {
        cachedMode = 'production'
        return cachedMode
      }
      if (mode === 'sandbox' || mode === 'test') {
        cachedMode = 'sandbox'
        return cachedMode
      }
    }
  } catch {
    // fall through
  }

  // Default sandbox (test mode only — never assume production on live builds)
  cachedMode = 'sandbox'
  return cachedMode
}
